import { render, staticRenderFns } from "./CamposDeProdutoComVariantes.vue?vue&type=template&id=523c9364&"
import script from "./CamposDeProdutoComVariantes.vue?vue&type=script&lang=ts&"
export * from "./CamposDeProdutoComVariantes.vue?vue&type=script&lang=ts&"
import style0 from "./CamposDeProdutoComVariantes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDivider,VExpansionPanels,VRow})
